import React from 'react'

interface LazyRouteErrorBoundaryProps {
  children: React.ReactNode
}

interface LazyRouteErrorBoundaryState {
  hasError: boolean
  error: Error | null
}

export class LazyRouteErrorBoundary extends React.Component<
  LazyRouteErrorBoundaryProps,
  LazyRouteErrorBoundaryState
> {
  constructor(props: LazyRouteErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error: Error): LazyRouteErrorBoundaryState {
    return { hasError: true, error }
  }

  private handleRetry = () => {
    this.setState({ hasError: false, error: null })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[60vh] flex items-center justify-center">
          <div className="text-center max-w-md p-6">
            <h2 className="text-xl font-bold text-red-400 mb-2">
              Failed to load page
            </h2>
            <p className="text-gray-300 mb-4">
              The page could not be loaded. This may be due to a network issue.
            </p>
            <p className="text-sm text-white/50 mb-4">
              {this.state.error?.message}
            </p>
            <button
              onClick={this.handleRetry}
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
            >
              Try again
            </button>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}
